const CommonMixin = {
  props: [
    'activity',
    'slide_id',
    'slide_result',
    'slide_index',
    'slide_result',
    'slide',
    'current_slide_index',
    'on_last_slide',
    'goToNextSlide',
    'info_opened',
    'is_authenticated',
    'toggleActivityOverlay',
    'toggleResourceOverlay',
    'updateResult',
    'updateCurrentActivity',
    'toggleSignInOverlay'
  ],

  data() {
    return {
      visible:      false
      // hammertime:   null
    }
  },

  mounted() {
    $(this.$el).addClass(`slide-${this.activity.id}`)

    // Background image
    if (this.activity.background_image &&
      this.activity.type !== 'activity_v1_videos' &&
      this.activity.type !== 'activity_v1_audios'
    ) {
      $(this.$el).css('background-image', `url(${this.activity.background_image})`)
    }

    // Gradient Background
    if (!this.activity.background_image &&
        this.activity.gradient_start &&
        this.activity.type !== 'activity_v1_videos' &&
        this.activity.type !== 'activity_v1_audios'
    ) {
      const start = this.activity.gradient_start
      const end = this.activity.gradient_end || this.activity.gradient_start
      const gradient = `linear-gradient(137deg, ${start} 0%, ${end} 92%)`
      $(this.$el).css('background-image', gradient)
    }

    // becameVisible logic
    if (this.current_slide_index === this.slide_index) {
      this.visible = true
      // this.enableScrolling()
      // this._globalBecameVisible()
      this.becameVisible()
    } else {
      this.$el.classList.add('slide-invisible')
    }
  },

  watch: {
    current_slide_index: function(val) {
      if (this.current_slide_index === this.slide_index) {
        this.visible = true
        this.$el.classList.remove('slide-invisible')
        // this.disableScrolling()
        // setTimeout(() => {
        //   this.enableScrolling()
        // }, 400)
        // this._globalBecameVisible()
        this.becameVisible()
      } else {
        if (this.visible) {
          this.visible = false
          setTimeout(() => {
            if (!this.visible) this.$el.classList.add('slide-invisible')
          }, 700)
          // this.disableScrolling()
          this.becameHidden()
        }
      }
    }
  },

  methods: {
    becameVisible() {
      this.markSlideAsViewed()
    },

    becameHidden() {},

    enableScrolling() {
      $(this.$el).on('wheel', this.scrollSlide.bind(this))
    },

    disableScrolling() {
      $(this.$el).off('wheel')
    },

    scrollSlide(event) {
      // disable slide scrolling when Wistia video is in full screen mode:
      if ($('[id$="_tmp_body_id"]').length) return false
      this.$emit('scroll', event)
    },

    markSlideAsViewed() {
      this.updateResult('viewed')
    }
  }
}

export default CommonMixin
